module.exports = "<p>\n  payment-arrears-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/payment-arrears/payment-arrears-form/payment-arrears-form.component.html
// module id = ./src/app/recovery/payment-arrears/payment-arrears-form/payment-arrears-form.component.html
// module chunks = main